var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-header" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "form-group" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("p", { domProps: { textContent: _vm._s(_vm.product.name) } })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "form-group" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _vm.product.state == 1
                ? _c("span", { staticClass: "btn btn-success btn-sm" }, [
                    _vm._v("Activo")
                  ])
                : _c("span", { staticClass: "btn btn-danger btn-sm" }, [
                    _vm._v("Desactivado")
                  ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "form-group row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "input-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.search,
                    expression: "search"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  placeholder: "Ingrese el numero de venta"
                },
                domProps: { value: _vm.search },
                on: {
                  keyup: function($event) {
                    return _vm.fetchData(1, _vm.product.id, _vm.search)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.search = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-theme",
                  attrs: { type: "submit" },
                  on: {
                    click: function($event) {
                      return _vm.fetchData(1, _vm.product.id, _vm.search)
                    }
                  }
                },
                [
                  _c("i", { staticClass: "icon-fa icon-fa-search" }),
                  _vm._v(" Buscar")
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("table", { staticClass: "table table-responsive" }, [
          _vm._m(3),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.productsArray, function(products) {
              return _c("tr", { key: products.id }, [
                _c("td", { domProps: { textContent: _vm._s(products.name) } }),
                _vm._v(" "),
                _c("td", [
                  products.state == 1
                    ? _c("span", { staticClass: "btn btn-success btn-sm" }, [
                        _vm._v("Activo")
                      ])
                    : _c("span", { staticClass: "btn btn-danger btn-sm" }, [
                        _vm._v("Desactivado")
                      ])
                ]),
                _vm._v(" "),
                _c("td", {
                  domProps: { textContent: _vm._s(products.created_at) }
                }),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    [
                      _c("div", { staticClass: "table__actions" }, [
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.top-center",
                                value: "Editar medida",
                                expression: "'Editar medida'",
                                modifiers: { "top-center": true }
                              }
                            ],
                            staticClass: "btn btn-theme btn-block",
                            on: {
                              click: function($event) {
                                return _vm.openModal("update", products)
                              }
                            }
                          },
                          [_c("i", { staticClass: "icon-fa icon-fa-pencil" })]
                        ),
                        _vm._v(" "),
                        _c("a"),
                        _vm._v(" "),
                        products.state == 1
                          ? _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip.top-center",
                                    value: "Desactivar medida",
                                    expression: "'Desactivar medida'",
                                    modifiers: { "top-center": true }
                                  }
                                ],
                                staticClass: "btn btn-danger btn-block",
                                on: {
                                  click: function($event) {
                                    return _vm.openModal("deactivate", products)
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "icon-fa icon-fa-trash"
                                })
                              ]
                            )
                          : _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip.top-center",
                                    value: "Activar medida",
                                    expression: "'Activar medida'",
                                    modifiers: { "top-center": true }
                                  }
                                ],
                                staticClass: "btn btn-info btn-block",
                                on: {
                                  click: function($event) {
                                    return _vm.openModal("activate", products)
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "icon-fa icon-fa-check"
                                })
                              ]
                            )
                      ])
                    ]
                  ],
                  2
                )
              ])
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c(
              "ul",
              { staticClass: "pagination pagination-primary m-b-0" },
              [
                _vm.pagination.current_page > 1
                  ? _c("li", { staticClass: "page-item" }, [
                      _c(
                        "a",
                        {
                          staticClass: "page-link",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.changePage(
                                _vm.pagination.current_page - 1,
                                _vm.search
                              )
                            }
                          }
                        },
                        [_c("i", { staticClass: "icon-fa icon-fa-angle-left" })]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.pagesNumber, function(page) {
                  return _c(
                    "li",
                    {
                      key: page,
                      staticClass: "page-item",
                      class: [page == _vm.isActived ? "active" : ""]
                    },
                    [
                      _c("a", {
                        staticClass: "page-link",
                        attrs: { href: "#" },
                        domProps: { textContent: _vm._s(page) },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.changePage(page, _vm.search)
                          }
                        }
                      })
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.pagination.current_page < _vm.pagination.last_page
                  ? _c("li", { staticClass: "page-item" }, [
                      _c(
                        "a",
                        {
                          staticClass: "page-link",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.changePage(
                                _vm.pagination.current_page + 1,
                                _vm.search
                              )
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "icon-fa icon-fa-angle-right"
                          })
                        ]
                      )
                    ])
                  : _vm._e()
              ],
              2
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h3", { staticClass: "page-title" }, [_vm._v("Kardex")]),
      _vm._v(" "),
      _c("ol", { staticClass: "breadcrumb" }, [
        _c("li", { staticClass: "breadcrumb-item" }, [
          _c("a", { attrs: { href: "#" } }, [_vm._v("Home")])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "breadcrumb-item" }, [
          _c("a", { attrs: { href: "#" } }, [_vm._v("Productos")])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "breadcrumb-item active" }, [_vm._v("Kardex")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("strong", [_vm._v("Nombre del producto")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("strong", [_vm._v("Estado")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Nombre")]),
        _vm._v(" "),
        _c("th", [_vm._v("Estado")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha de registro")]),
        _vm._v(" "),
        _c("th", [_vm._v("Opciones")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a9d5eb7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a9d5eb7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/admin/products/Kardex.vue
// module id = 604
// module chunks = 0